(function(){
 'use strict';
 var nav=document.querySelector('[data-bakery-mobile-actions]');if(!nav)return;
 var hub=!!window.LarrysaShopifyConfig;
 function sync(){
  var count=hub?document.getElementById('hud-basket-count'):null;
  if(count&&nav.querySelector('[data-mobile-order-count]').textContent!==count.textContent)nav.querySelector('[data-mobile-order-count]').textContent=count.textContent;
  nav.querySelectorAll('[data-mobile-action]').forEach(function(link){
   var destination=new URL(link.href);
   var active=hub?document.body.dataset.drawer===link.dataset.mobileAction:destination.pathname===location.pathname&&(destination.hash?destination.hash===location.hash:location.hash!=='#assistente');
   if(active)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');
  });
  var social=document.querySelector('#shop-panel .social-strip');
  if(social){
   social.dataset.followLabel=window.larrysaT?window.larrysaT('Siga-nos'):'Siga-nos';
   var website=social.querySelector('a[href="https://www.larrysasbakery.com/"]');
   if(website&&!website.querySelector('.bakery-social-globe'))website.insertAdjacentHTML('afterbegin','<svg class="bakery-social-globe" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18M5 6.5h14M5 17.5h14"/></svg>');
  }
  var toggle=document.querySelector('.photographic-room .langtog--float');
  var controls=document.getElementById('studio-bar');
  if(toggle&&controls){if(matchMedia('(max-width:1040px)').matches){if(toggle.parentElement!==controls)controls.append(toggle);}else if(toggle.parentElement!==document.body)document.body.append(toggle);}
 }
 nav.addEventListener('click',function(event){
  var link=event.target.closest('[data-mobile-action]');
  if(!hub||!link||link.dataset.mobileAction==='whatsapp')return;
  var api=window.__lojaViva3D;
  if(api){event.preventDefault();api.openDrawer(link.dataset.mobileAction);sync();window.larrysaApplyLang?.();}
 });
 if(hub){
  var frame=0,observer=new MutationObserver(function(){if(frame)return;frame=requestAnimationFrame(function(){frame=0;observer.disconnect();sync();watch();});});
  function watch(){observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-shop-ready','data-drawer']});}
  sync();watch();
  var deepLinkDone=false;
  var ready=new MutationObserver(function(){if(!deepLinkDone&&document.body.dataset.shopReady==='true'&&location.hash==='#assistente'){deepLinkDone=true;window.__lojaViva3D?.openDrawer('ajuda');ready.disconnect();}});
  ready.observe(document.body,{attributes:true,attributeFilter:['data-shop-ready']});
  if(document.body.dataset.shopReady==='true'&&location.hash==='#assistente'){deepLinkDone=true;window.__lojaViva3D?.openDrawer('ajuda');ready.disconnect();}
 }else{
  // Read the current basket only. Adding, updating and submitting stay with existing flows.
  function readCount(){fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error();return r.json();}).then(function(cart){nav.querySelector('[data-mobile-order-count]').textContent=String(cart.item_count||0);}).catch(function(){});}
  sync();readCount();window.addEventListener('pageshow',readCount);
  document.addEventListener('cart:updated',readCount);document.addEventListener('cart:change',readCount);
 }
 window.addEventListener('hashchange',sync);window.addEventListener('larrysa:lang',sync);window.addEventListener('resize',sync);
})();
